import { languages } from "../languages";

//English
const location_en = "Edmundston";
const locale_en = "en-ED";
const language_en = languages[locale_en.slice(0,2)](location_en)
const slugs_en = language_en.slugs;
const messages_en = language_en.messages;

//French
const location_fr = "Edmundston";
const locale_fr = "fr-ED";
const language_fr = languages[locale_fr.slice(0,2)](location_fr)
const slugs_fr = language_fr.slugs;
const messages_fr = language_fr.messages;



// const testFolder = './tests/';
// const fs = require('fs');

// fs.readdirSync(testFolder).forEach(file => { console.log(file); });

const contactInfo = {
  "contact-info.telephone-number": "1-506-501-2241",
  "contact-info.email": "edmundston@andmar.ca",
}

const customData = {
  "PresentationImage":"EdmundstonPresentation",
}



export const edmundston ={
  en:{
    locale:locale_en,
    prefix: `${location_en.toLowerCase().replace(/\s/g, '')}/${locale_en.slice(0,2)}`,//edmundston/en
    slugs: {...slugs_en},
    messages: {...messages_en, ...contactInfo, ...customData},
  },
  fr:{
      locale:locale_fr,
      prefix: `${location_fr.toLowerCase().replace(/\s/g, '')}/${locale_fr.slice(0,2)}`,//edmundston/fr
      slugs: {...slugs_fr},
      messages: {...messages_fr, ...contactInfo, ...customData},
    }
    
};



